import { apiRequest } from '@/utils/request'

export function getSection(queryParams) {
  return apiRequest({
    url: '/section',
    method: 'get',
    params: queryParams
  })
}

export function getArticlePagedList(queryParams) {
  return apiRequest({
    url: '/article/getPagedList',
    method: 'get',
    params: queryParams
  })
}

export function readArticle(id) {
  return apiRequest({
    url: '/article/read/' + id,
    method: 'get'
  })
}

export function getArticleView(queryParams) {
  return apiRequest({
    url: '/Article/GetView',
    method: 'get',
    params: queryParams
  })
}
